import React from "react";
import UnityPlayer from "./components/UnityPlayer.tsx";
import WebcamPoseProvider from "./components/WebcamPoseProvider.tsx";
import RemotePlay from "./components/RemotePlay.tsx";
import PasswordGate from "./components/PasswordGate.tsx";
import QuestShareCard from "./components/QuestShareCard.tsx";
import QuestMap from "./components/QuestMap.tsx";
import { initTelemetry } from "./telemetry.ts";
import { initPoseRecorder, isCapture } from "./poseRecorder.ts";
import CaptureSession from "./components/CaptureSession.tsx";
import HomeScreenHint from "./components/HomeScreenHint.tsx";
import "./App.css";

initTelemetry();
initPoseRecorder();

const App: React.FC = () => {
  return (
    <div className="App">
      <PasswordGate>
        <div className="vidContainer">
          {/* capture mode is standalone: pose pipeline only, no game */}
          {!isCapture && <UnityPlayer />}
          <WebcamPoseProvider />
          {!isCapture && <RemotePlay />}
          {!isCapture && <QuestShareCard />}
          {!isCapture && <QuestMap />}
          <CaptureSession />
          {!isCapture && <HomeScreenHint />}
        </div>
      </PasswordGate>
    </div>
  );
};

export default App;
